import React from 'react';
import { FaSpider, FaPlay } from 'react-icons/fa';

const ScrapperPanel = ({
  scrapperQuery,
  setScrapperQuery,
  scrapperCategory,
  setScrapperCategory,
  scrapperMaxResults,
  setScrapperMaxResults,
  scrapperSort,
  setScrapperSort,
  isScraping,
  handleStartScraping,
  scrapingProgress
}) => {
  return (
    <div className="bg-gray-800 p-4 rounded-lg border border-gray-700 mb-6">
      <h3 className="text-lg font-semibold text-white mb-4 flex items-center">
        <FaSpider className="mr-2" />
        Play Store'dan Email Toplama
      </h3>
      <div className="flex items-end justify-end gap-3 mb-4">
        <div className="flex-1 min-w-64">
          <label className="block text-xs font-medium text-gray-300 mb-1">Arama Terimi</label>
          <input
            type="text"
            placeholder="örn: fitness apps, oyunlar"
            className="w-full px-3 py-3 bg-gray-700 border border-gray-600 text-white rounded text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
            value={scrapperQuery}
            onChange={(e) => setScrapperQuery(e.target.value)}
          />
        </div>
        
        <div className="w-32 flex-shrink-0">
          <label className="block text-xs font-medium text-gray-300 mb-1">Sıralama</label>
          <select
            className="w-full px-3 py-3 bg-gray-700 border border-gray-600 text-white rounded text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
            value={scrapperSort}
            onChange={(e) => setScrapperSort(e.target.value)}
          >
            <option value="newest">En Yeni</option>
            <option value="relevance">En Popüler</option>
            <option value="rating">En Yüksek Puan</option>
            <option value="price">Fiyat</option>
          </select>
        </div>
        
        <div className="w-24 flex-shrink-0">
          <label className="block text-xs font-medium text-gray-300 mb-1">Maksimum Sonuç</label>
          <input
            type="number"
            min="1"
            max="100"
            className="w-full px-3 py-3 bg-gray-700 border border-gray-600 text-white rounded text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
            value={scrapperMaxResults}
            onChange={(e) => setScrapperMaxResults(parseInt(e.target.value))}
          />
        </div>
        
        <div>
          <label className="block text-xs font-medium text-gray-300 mb-1">&nbsp;</label>
          <button
            onClick={handleStartScraping}
            disabled={isScraping || !scrapperQuery.trim()}
            className="px-6 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
          >
            <FaPlay className="mr-2" />
            {isScraping ? 'Toplanıyor...' : 'Email Toplamaya Başla'}
          </button>
        </div>
      </div>
      
      {/* Progress Display */}
      {isScraping && (
        <div className="mt-4 p-3 bg-gray-700 rounded-lg">
          <div className="flex items-center justify-between text-sm">
            <div className="flex items-center">
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500 mr-2"></div>
              <span className="text-gray-300">
                Uygulamalar işleniyor...
              </span>
            </div>
            <div className="text-green-400 font-medium">
              {scrapingProgress.foundEmails}/{scrapingProgress.targetEmails}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ScrapperPanel;
